import { create } from 'zustand'
import { postData } from 'helpers/api'

export const useFavoritesStore = create((set) => ({
  favorites: {},

  setFavorites: async () => {
    const data = await postData('favorites/')
    set({ favorites: data })
    return data
  },
}))
